// Reusable effects system — maps cosmetic metadata to CSS classes and piece styles.
// Phase 4 will wire these into the live board renderer.

export function getPieceStyleFromCosmetic(cosmetic, isWhite) {
  if (!cosmetic || cosmetic.category !== 'pieces') return null;
  const { preview } = cosmetic;
  const color = isWhite ? preview.pieceColor : (preview.darkColor || '#1C1A2E');
  const glow  = preview.glowColor;
  return {
    color,
    textShadow: glow
      ? `0 0 10px ${glow}, 0 0 22px ${glow}80, 0 1px 3px rgba(0,0,0,0.5)`
      : '0 1px 4px rgba(0,0,0,0.55)',
  };
}

export function getBoardColorsFromCosmetic(cosmetic) {
  if (!cosmetic || cosmetic.category !== 'board') return null;
  return {
    light:     cosmetic.preview.lightSquare,
    dark:      cosmetic.preview.darkSquare,
    selected:  '#FFD700',
    lastLight: cosmetic.preview.lightSquare,
    lastDark:  cosmetic.preview.darkSquare,
  };
}

// Returns a CSS class to add to the piece's parent square element.
export function getSquareEffectClass(effects = []) {
  if (effects.includes('glow_violet'))    return 'fx-glow';
  if (effects.includes('glass_render'))   return 'fx-glass';
  if (effects.includes('glitch_flicker')) return 'fx-glitch';
  return '';
}

// Returns a CSS class to add to the board wrapper element.
export function getBoardEffectClass(effects = []) {
  if (effects.includes('neon_lines')) return 'fx-neon-board';
  return '';
}
